<template>
  <div class="column-wrapper">
      <ul class="chat-list" ref="chat">
        <li v-if="ticketId" class="text-center m-t-10"><span class="badge badge-pill badge-info"><i class="fa fa-map-marker p-r-10"></i>{{ location }}</span></li>
        <li v-for="message of messages" :key="message.key" :class="{'reverse by-representative': message.byRepresentative}">
          <chat-message :message="message"></chat-message>
        </li>
        <li ref="chatBottom" class="chat-bottom"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage';

export default {
  name: 'chat',
  props: {
    messages: {
      type: Array,
      required: true,
    },
    ticketId:  String,
    location: String,
  },
  components: {
    ChatMessage,
  },
  filters: {
    shorten: function (value) {
      return (value) ? value.slice(value.length - 4) : '';
    }
  },
};
</script>

<style lang="scss">
.chat-main-header {
  font-weight: 500;

  .ticket-info {
    position: relative;

    & > hr {
      position: absolute;
      width: 100%;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    .ticket-box {
      position: relative;
      padding: 0 20px;
      margin-bottom: 0;
      font-size: 14px;
      border: 1px solid black;
      display: inline-block;
      background: white;
    }
  }
  .name-input {
    border: 0;
    background: transparent;
    flex: 1 1 auto;

    &:placeholder-shown {
      color: grey;
    }
  }
}

.chat-rbox {
  display: flex;
  flex-grow: 1;
  overflow: auto;

  .chat-list {
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;

    & > li {
      &.by-representative {
        .chat-wrapper {
          flex-direction: row-reverse;
          .chat-content {
            padding-right: 0;
          }
        }
      }

      .chat-wrapper {
        display: flex;
        align-items: center;
        padding-left: 15px;
        padding-right: 15px;

        .chat-content {
          flex-grow: 1;
          padding-left: 0;
        }

        .chat-time {
          text-transform: lowercase;
        }
      }
    }

    .chat-bottom {
      margin-top: 0;
    }
  }
}
.card-body {
  flex-grow: 0;

  textarea {
    &:focus {
      border: none;
      outline: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Chat.vue